import script from "./BidContent.vue?vue&type=script&setup=true&lang=js"
export * from "./BidContent.vue?vue&type=script&setup=true&lang=js"

import "./BidContent.vue?vue&type=style&index=0&id=90eb8566&lang=scss"

const __exports__ = script;

export default __exports__